import React ,{ useEffect, useState }from 'react';
import {
  SurveyContainerContainer,
  SurveyContainerContent,
  SurveyContainerHead,
  SurveyContainerBody,
  SurveyContainerBodyIcon,
  SurveyContainerBodyLabel,
  SurveyContainerBodyDescription,
  SurveyContainerFooter,
  SurveyContainerFooterButton,
} from './styles';
import SurveyRadioButtons from '../SurveyRadioButtons';
import SurveyWindow from '../SurveyWindow';
import { IoClose } from 'react-icons/io5';
import colors from '../../assets/styles/colors';
import { createAnswer, updateLastSurvey } from '../../services/survey';


const SurveyContainer = ({steps, open, idAsesor}) => {
  const [current, setCurrent] = useState(0);
  const [visible, setVisible] = useState(open);

  async function onAnswered(idQuestion, answer)
  {
    await createAnswer(idAsesor, idQuestion, {respuesta: answer});
    setCurrent(current+1);
    await updateLastSurvey(idAsesor);
  }

  return (
    <SurveyContainerContainer open={open && steps && current < steps.length} id="survey-container">
      {steps && steps.map((item, key)=> (
        <SurveyWindow 
          key={item.id} 
          step={key + 1} 
          question={(key != 0) 
            ? item.pregunta 
            : (<div><div>Hola!</div><div>Queremos realizar una breve encuesta de satisfacción.</div><div>{item.pregunta}</div></div>)} 
          open={current == key} 
          maxValue={item.valorMaximo}
          minValue={item.valorMinimo}
          idQuestion={item.id}
          actionNext={onAnswered}/>
      ))}
    </SurveyContainerContainer>
  )
}

export default SurveyContainer
